import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';


class ApplicantLogin {

  
    GetRegesterdData(ApplicantID){
                
        return axios.post(API_URL + `Security/GetRegesterdUserData?ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
        
     }
     GetNationalityList(){
        return axios.get(API_URL + 'Lookup/GetNationalitySelectAll')
        }
      GetGendelList(){
        
            return axios.get(API_URL + 'Lookup/GetGenderSelectAll')
     }
     GetReligionList(){
        return axios.get(API_URL + 'Lookup/GetReligionsSelectAll')

     }
     GetGovernorate(CountryID){
      return axios.get(API_URL + `Lookup/GetGovernorate?CountryId=${CountryID}`,{
        
      },
      { headers: authHeader() })
     }
     GetCountriesSelectAll(){
      return axios.get(API_URL + 'Lookup/GetCountriesSelectAll',{
        
      },
      { headers: authHeader() })
     }
     CertificationTypeSelectAll(){
      return axios.get(API_URL + 'Lookup/CertificationTypeSelectAll',{
        
      },
      { headers: authHeader() })
     }
     GetCertificationYears(){
      return axios.get(API_URL + 'Lookup/GetCertificationYears',{
        
      },
      { headers: authHeader() })
     }
     GetCertificationSpecialization(CertificateID){
      return axios.get(API_URL + `Lookup/SpecializationType_SelectByID?CertificateType=${CertificateID}`,{
        
      },
      { headers: authHeader() })

     }
     GetBranchesAPI(){
      return axios.get(API_URL + `Lookup/GetBranchesAPI`,{
        
      },
      { headers: authHeader() } )
    }
    GetFacultyBranchesAPI(BranchID){
      return axios.get(API_URL + `Lookup/FacultyByBranchAPI?BranchId=${BranchID}`,{
        
      },
      { headers: authHeader() } )
      }
    GetActiveFacultyBranchesAPI(BranchID){
      return axios.get(API_URL + `Lookup/FacultyActiveByBranchAPI?BranchId=${BranchID}`,{
        
      },
      { headers: authHeader() } )
      }
    GetEnrollmentStatus(){
      return axios.get(API_URL + `Lookup/GetEnrollmentStatus`,{
        
      },
      { headers: authHeader() } )
      }
    GetlistOfPreferences(){
      return axios.get(API_URL + `ApplicantData/GetlistOfPreferences`,{
        
      },
      { headers: authHeader() } )
      }
      GetActiveAvailableSemester(){
      return axios.get(API_URL + `Lookup/GetActiveAvailableSemester`,{
        
      },
      { headers: authHeader() } )
      }
      GetAttachmentTypes(){
      return axios.get(API_URL + `FileAttachments/FileAttachmentsTypes_SelectAll`,{
        
      },
      { headers: authHeader() } )
      }
      GetAllExamTypes(){
      return axios.get(API_URL + `Exams/GetAllExamTypes`,{
        
      },
      { headers: authHeader() } )
      }
      GetChangeAllExamTypes(){
      return axios.get(API_URL + `Exams/GetAllExamTypesToChange`,{
        
      },
      { headers: authHeader() } )
      }
      GetAllEquivalentExamTypes(){
      return axios.get(API_URL + `Exams/GetAllEquivalentExamTypes`,{
        
      },
      { headers: authHeader() } )
      }
      GetAllCertificationFileAttachment(){
      return axios.get(API_URL + `Exams/GetAllCertificationFileAttachment`,{
        
      },
      { headers: authHeader() } )
      }
      PostExamDatesLocationsAPI(ExamID,ApplicantExamID){
      return axios.get(API_URL + `Exams/PostExamDatesLocationsAPI?ExamID=${ExamID}&ApplicantExamID=${ApplicantExamID}`,{
        
      },
      { headers: authHeader() } )
      }
      GetTermsandConditions(){
        return axios.get(API_URL + `TermsAndCondition/GetCurrentTermAndCondition`,{
        
        },
        { headers: authHeader() } )
      }
      GetHelpPages(PageID){
        return axios.get(API_URL + `HelpPages/SelectHelpPageAndSection?PageId=${PageID}`,{
        
        },
        { headers: authHeader() })
      }

     
      GetQualificationExams(ApplicantID){
        return axios.get(API_URL + `Exams/GetQualificationExams?ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }

      UpdateUploadEquivalentExamFile(ApplicantExamID, ApplicantID){
        return axios.post(API_URL + `Exams/UpdateWillUploadEquivalentExamFile?ApplicantExamID=${ApplicantExamID}&ApplicantID=${ApplicantID}`,{
        
        },
        { headers: authHeader() })
      }

}

export default new ApplicantLogin();
